import { UiLoader } from '@experiences/ui-common';
import {
    hasAuthParams,
    useAuth,
} from '@uipath/auth-react';
import React, {
    useEffect,
    useState,
} from 'react';
import {
    Navigate,
    useParams,
} from 'react-router';

const AuthCallback = () => {
    const { error } = useAuth();
    const { accountName } = useParams() as { accountName?: string };

    const [ shouldNavigate, setShouldNavigate ] = useState(false);

    useEffect(() => {
        if (!hasAuthParams() || error) {
            setShouldNavigate(true);
        }
    }, [ error ]);

    // redirect if user is stuck or error has occurred
    if (shouldNavigate) {
        return <Navigate
            data-cy='auth-callback-navigate'
            to={
                `${accountName ? `/${accountName}` : ''}/portal_/cloudrpa`
            }
        />;
    }

    return <UiLoader type="full" />;
};

export default AuthCallback;
